import { gql } from '@apollo/client';

export const getUserBusinessUnits = gql`
  query getUserBusinessUnits {
    getUserBusinessUnits {
      id
      name
    }
  }
`;
